import { applyDiscountPercent } from '@lib/product/price'

/**
 * Rounds a number to at most given precision.
 */
export const roundNumber = (value: number | string, precision = 0) => {
  return +parseFloat(`${value}`).toFixed(precision)
}

/**
 * Formats a number for printing as price.
 */
export const formatPrice = (
  value: number,
  alwaysShowDigits = false,
  digitCount = 2,
) => {
  const valueNumber = Number(value)

  const maxMinorValue = Math.pow(10, digitCount)
  const hasMinorDigits =
    Math.round(valueNumber * maxMinorValue) % maxMinorValue !== 0
  const effectiveDigitCount =
    alwaysShowDigits || hasMinorDigits ? digitCount : 0

  return valueNumber.toLocaleString(undefined, {
    minimumFractionDigits: effectiveDigitCount,
    maximumFractionDigits: effectiveDigitCount,
    useGrouping: false,
  })
}

/**
 * Subtracts discount percentage from price.
 */
export const getPriceWithDiscount = (
  price: number,
  discountPercent?: number | null,
) => {
  if (!discountPercent) {
    return price
  }

  const normalizedDiscountPercent = Math.max(0, Math.min(100, discountPercent))
  const priceWithDiscount = applyDiscountPercent(
    price,
    normalizedDiscountPercent,
  )

  return priceWithDiscount!
}
